export default "__VITE_PUBLIC_ASSET__17e31d6c__"